module.exports = __webpack_public_path__ + "img/etc-etc-new-arrow-l-b.ea546783.svg";